module.exports = __webpack_public_path__ + "static/media/19ESCAP20.e00cfbde.jpg";